<footer class="register-user__geolocation-footer">
  <ci-button
    [class-name]="'ci-btn-primary-s-filled'"
    class="geolocation-footer__next-button"
    (click)="handleRequestGeolocation(true)"
  >
    {{ 'Solicitar geolocalización' | translate }}
  </ci-button>
  
  <ci-text-button
    class-name="ci-text-btn-primary-s"
    class="geolocation-footer__prev-button"
    (click)="handleRequestGeolocation(false)"
  >
    {{ 'No me interesa' | translate }}
  </ci-text-button>
</footer>  